import {Component, Inject, OnInit, Output, EventEmitter, ViewChild} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
// import { HttpErrorResponse } from '@angular/common/http';
import {ActiveQuoteDetails, FacilityDetails, FacilityTerms, QuoteInfo, TermDetails} from "./active-quote-details.model";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
// import {FormBuilder, FormGroup} from "@angular/forms";
import {ActiveTermsDialogComponent} from "../active-terms-dialog/active-terms-dialog.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActiveQuotesService} from "../../../services/active-quotes.service";
import {MatTableDataSource} from "@angular/material/table";
import {environment} from "../../../../environments/environment"
import {MatSort} from "@angular/material/sort";
import {DownloadContractDialogComponent} from "../download-contract-dialog/download-contract-dialog.component";
import {UtilService} from "../../../services/util.service";
import {DataService} from "../../../services/data.service";
// import {MatPaginator, PageEvent} from "@angular/material/paginator";

@Component({
  selector: 'app-active-quote-dialog',
  templateUrl: './active-quote-dialog.component.html',
  styleUrls: ['./active-quote-dialog.component.scss']
})
export class ActiveQuoteDialogComponent implements OnInit {
  // searchForm: FormGroup;
  hideOpportunity: boolean;
  hideCommentAction: boolean;
  @Output() dialogClose = new EventEmitter();
  quoteInfo: QuoteInfo = {
    opportunityName: "",
    quoteNumber: "",
    userComment: ""
  }
  displayedColumns: string[] = ["quoteMeterFacilityName", "quoteMeterFacilityNumber", "quoteMeterStartDate", "quoteMeterUtility", "billTypeName"];
  quoteMeterList: MatTableDataSource<FacilityDetails>;
  // facilitiesList: FacilityDetails[];
  // pageEvent!: PageEvent;
  isLoading: boolean = false;
  // @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  constructor(@Inject(MAT_DIALOG_DATA) private data, public dialog: MatDialog, private httpService: HttpClient, private snackBar: MatSnackBar, private quoteService: ActiveQuotesService, public utilService: UtilService, private dataService: DataService ) { }
  quoteDetails: ActiveQuoteDetails = {} as ActiveQuoteDetails;
  facilityTerms: FacilityTerms[] = [];
  termActive = [];
  contractDisabled: boolean = false;

  async ngOnInit(): Promise<void> {
    let {quoteDetail: quoteData} = this.data;
    if(quoteData.terms && quoteData.terms.length) {
      let startDate = new Date(quoteData.startDate);
      quoteData.terms.forEach((termItem, ind) => {
        quoteData.terms[ind]['endDate'] = new Date(startDate.getFullYear(), startDate.getMonth() + 1 + termItem.term, 0)
      })
    }
    // if(quoteData.market){
      // if(quoteData.market === 'ERCOT')
      //   this.displayedColumns = this.displayedColumns.concat(["startDateType", "transactionType"])
      // if(quoteData.market === 'PJM')
      //   this.displayedColumns = this.displayedColumns.concat(["PLC", "NSPL"])
    // }

    quoteData.quoteInfo = quoteData.quoteInfo || this.quoteInfo;
    this.isLoading = true;
    this.getFacilityTerms(quoteData.quoteNumber);
    // this.httpService.get('./assets/facilities.json'). subscribe(

    this.quoteDetails = quoteData as ActiveQuoteDetails;
    this.getJurisdiction();
    // this.httpService.get('./assets/activeDetails.json'). subscribe(
    //   data => {
    //     this.quoteDetails = data as ActiveQuoteDetails;
    //     console.log(this.quoteDetails);
    //   },
    //   (err: HttpErrorResponse) =>{
    //     console.log(err.message);
    //   }
    // );

  }

  makeFacilities(facilities: FacilityDetails[], term?, mergeTerms?){
    let list = facilities.map((item: any) => {
      if(!term) {
        const {
          dataMeter: {dataFacility, dataUtility},
          quoteMeterStartDate,
          quoteMeterEndDate,
          quoteTermMeterStartDate,
          quoteTermMeterEndDate,
          quoteTermObligationSummary,
          quoteTerm
        } = item;
        let obj = {
          quoteMeterFacilityName: dataFacility.facilityName,
          quoteMeterFacilityNumber: dataFacility.facilityNumber,
          quoteMeterStartDate: quoteMeterStartDate || quoteTermMeterStartDate,
          quoteMeterEndDate: quoteMeterEndDate || quoteTermMeterEndDate,
          quoteMeterUtility: dataUtility.utilityName,
          billTypeName: item.billTypeName || item.quoteMeter.billTypeName,
          quoteTerm: quoteTerm,
          serviceAddress: this.getFullAddress(dataFacility)
        } as FacilityDetails;
        if (quoteTermObligationSummary) {
          let {PLC, NSPL} = quoteTermObligationSummary;
          obj.PLC = PLC;
          obj.NSPL = NSPL;
        }
        return obj;
      }else{
        if(item.quoteTerm != term)
          return item
      }
    }).filter(item => item != undefined);

    if(mergeTerms && this.termActive.length >= 2  ){
      list = list.concat(this.quoteMeterList.data);
    }
    // this.facilitiesList = list;
    let filterByFacility = [];
    list.forEach(item => {
      if(filterByFacility.length){
        let found = false;
        for(let facilityItem of filterByFacility) {
          if(facilityItem.quoteMeterFacilityNumber == item.quoteMeterFacilityNumber){
            found = true;
            break;
          }
        }
        if(!found){
          filterByFacility.push(item)
        }
      }else{
        filterByFacility.push(item)
      }
    })
    this.quoteMeterList = new MatTableDataSource(filterByFacility as FacilityDetails[]);
    // this.quoteMeterList.paginator = this.paginator;
    this.quoteMeterList.sort = this.sort;
    // if(list[0] && list[0].quoteMeterFacilityNumber)
    //   this.quoteMeterList.filter = list[0].quoteMeterFacilityNumber.trim().toLowerCase();
  }

  getFullAddress(data){
    let address = `${data.facilityAddressLine1}, ${data.facilityAddressLine2}, ${data.facilityCity}, ${data.facilityState}, ${data.facilityPostalCode}`;
    address = address.replace(/, null/g, '');
    address = address.replace(/null, /g, '');
    return address
  }

  openTermsDetailDialog(){
    const dialogRef = this.dialog.open(ActiveTermsDialogComponent
      , {
        width: '600px',
        data: this.quoteDetails || {},
        panelClass: 'contract-generator-dialog'
      }
    );
    const closeListener = dialogRef.componentInstance.onClose.subscribe(()=>{
      dialogRef.close();
    })
    dialogRef.afterClosed().subscribe(result => {
      // console.log(`Dialog result: ${result}`);
      closeListener.unsubscribe();
    });
  }

  openDownloadContractDialog(){
    let facilities = [];
    if(this.quoteMeterList){
      facilities = this.quoteMeterList.data.map(item => {
        return {
          accountNumber: item.quoteMeterFacilityNumber,
          serviceAddress: item.serviceAddress,
          taxExempt: false
        }
      })
    }
    const dialogRef = this.dialog.open(DownloadContractDialogComponent
      , {
        // width: '800px',
        data: {pricing: this.termActive, facilities: facilities, quoteDetails: this.quoteDetails} || {},
        panelClass: 'contract-generator-dialog'
      }
    );
    const closeListener = dialogRef.componentInstance.onClose.subscribe(()=>{
      dialogRef.close();
      this.dialogClose.emit();
    })
    dialogRef.afterClosed().subscribe(result => {
      closeListener.unsubscribe();
    });
  }

  saveQuote(){
    let url = environment.apiUrl + `putnote/${this.quoteDetails.quoteNumber}/${this.quoteDetails.quoteInfo.userComment}`;
    // let url = `/putnote/${this.quoteDetails.quoteNumber}/${this.quoteDetails.quoteInfo.userComment}`
    this.httpService.put(url, {}).subscribe(res => {
      console.log(res);
      this.snackBar.open('User note Save Successfully', 'close', {
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['success-box']
      })
    }, (err: HttpErrorResponse) => {
      this.snackBar.open(`${err.message || 'Failed to add note'}`, 'close', {
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['error-box']
      })
    })
    this.hideCommentAction = !this.hideCommentAction;
  }

  closeDialog(){
    this.dialogClose.emit();
  }

  getFacilityTerms(quoteNumber: string, term?: number){
    this.isLoading = true;
    if(term) {
      this.quoteService.getFacilityTerms(quoteNumber, term).subscribe(
        (data: any) => {
          this.makeFacilities(data, null, 'merge');
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          console.log(err.message);
          this.isLoading = false;
        });
    }else{
      this.quoteService.getFacilities(quoteNumber).subscribe(
        data => {
          let facilities = data as FacilityDetails[];
          // quoteData.quoteMeterList = facilities;
          this.makeFacilities(facilities);
          this.isLoading = false;
        },
        (err: HttpErrorResponse) =>{
          console.log(err.message);
          this.isLoading = false;
        });
    }
  }

  termSelected(checked, data: TermDetails, termIndex: number){
    let {term, quoteId: quoteNumber} = data;
    if(checked) {
      this.getFacilityTerms(quoteNumber, parseInt(term));
      this.termActive.push(data);
    }else{
      this.termActive = this.termActive.filter(item => item.term != term);
      if(this.termActive.length){
        this.makeFacilities(this.quoteMeterList.data, term)
      }else{
        this.getFacilityTerms(quoteNumber);
      }
    }
  }

  saveOpportunityName(){
    this.quoteService.saveOpportunityName({quoteId: this.quoteDetails.quoteNumber, opportunityName: this.quoteDetails.quoteInfo.opportunityName}).subscribe(res => {
      this.hideOpportunity = !this.hideOpportunity;
      this.snackBar.open('Opportunity Name saved Successfully', 'close', {
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['success-box']
      })
    }), (err: HttpErrorResponse) => {
      this.snackBar.open(err.message || 'Failed to save', 'close', {
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['error-box']
      })
    } }

    async getJurisdiction(){
    this.isLoading = true;
      await this.dataService.getApiDataTextResp(`quote-contract-gen/disable/getjurisdiction/${this.quoteDetails.quoteNumber}`).toPromise().then(res => {
        this.dataService.getApiData(`quote-contract-gen/disable/isitdisabled/${res}`).subscribe(resp => {
          this.contractDisabled = resp as boolean;
        }, err => {

        })
      }).catch(err => {

      }).finally(() => {
        this.isLoading = false;
      })
    }
}
